import { TAG } from "../constants";
import {
  Availability,
  Encounter,
  EncounterStatus,
  Specialties,
} from "../types";
import { patientApi } from "./patientApi";

export const encounterApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getEncounters: builder.query<
      Encounter[],
      { status?: EncounterStatus } | void
    >({
      query: (params) => ({
        url: `/api/patient/encounters`,
        method: "GET",
        params: {
          ...params,
        },
      }),
      providesTags: [TAG.ENCOUNTERS],
    }),

    requestSyncVisit: builder.mutation<
      Encounter,
      {
        specialty: Specialties;
        provider_availability_id: number;
        start_at: string;
      }
    >({
      query: (body) => ({
        url: `/api/patient/encounters`,
        method: "POST",
        body,
      }),
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          encounterApi.util.updateQueryData(
            "getEncounters",
            { status: "requested" },
            (draft) => {
              if (draft != null) {
                draft.push(data);
              } else {
                draft = [data];
              }
            },
          ),
        );
      },
    }),
    getTimeSlots: builder.query<
      Availability,
      { specialty: Specialties; state: string } | void
    >({
      query: (params) => ({
        url: `/api/patient/time-slots`,
        method: "GET",
        params: {
          ...params,
        },
      }),
    }),
  }),
});

export const {
  useRequestSyncVisitMutation,
  useGetTimeSlotsQuery,
  useGetEncountersQuery,
} = encounterApi;
